import React, { FC } from "react";
import { Button, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  expandAllBtn: {
    width: "94px",
    height: "30px",
    textTransform: "none",
    color: theme.palette.primary.contrastText,
    backgroundColor: "#008AFC",
  },
}));

interface ExpandAllProps {
  areAllPanelsExpanded: boolean;
  toggleAllDetailPanels: () => void;
}

const ExpandAll: FC<ExpandAllProps> = ({ areAllPanelsExpanded, toggleAllDetailPanels }) => {
  const classes = useStyles();

  return (
    <Button variant="contained" size="small" className={classes.expandAllBtn} onClick={() => toggleAllDetailPanels()}>
      {areAllPanelsExpanded ? "Collapse All" : "Expand All"}
    </Button>
  );
};
export default ExpandAll;
